import { Layout } from "antd";
import { Outlet } from "react-router";
import AdminSidebar from "./adminSidebar";
import AdminTopbar from "./adminTopbar";

const { Content } = Layout;

export default function AdminShell(){

    return (
        <Layout className={'h-screen!'}>
            <AdminSidebar/>
            <Layout>
                <AdminTopbar/>
                <Content className="overflow-auto p-4 sm:p-5 md:p-6">
                    <Outlet/>
                </Content>
            </Layout>
        </Layout>
    )
}
